// extracted by mini-css-extract-plugin
module.exports = {"img":"_3kGvKvofWq-3TMAMXtNbVF","title":"_5AVnjEs3raViY4IUZYWLj","description":"_2gghBcml9l42Igg82ElPs6"};